import request from '@/utils/request'

const hostCorporationApi = {
  trade_bank_commercial_acceptance_list: '/trade/bank_commercial_acceptance/',
  trade_bank_commercial_acceptance_create: '/trade/bank_commercial_acceptance/',
  trade_bank_commercial_acceptance_update: '/trade/bank_commercial_acceptance/',
  trade_bank_commercial_acceptance_delete: '/trade/bank_commercial_acceptance/',
  trade_bank_commercial_acceptance_attachment_list: '/trade/bank_commercial_acceptance_attachment/',
  trade_bank_commercial_acceptance_attachment_create: '/trade/bank_commercial_acceptance_attachment/',
  trade_bank_commercial_acceptance_attachment_update: '/trade/bank_commercial_acceptance_attachment/',
  trade_bank_commercial_acceptance_attachment_delete: '/trade/bank_commercial_acceptance_attachment/'
}

/**
 * 列表
 */
export function bank_commercial_acceptance_list (parameter) {
  return request({
    url: hostCorporationApi.trade_bank_commercial_acceptance_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function bank_commercial_acceptance_create (parameter) {
  return request({
    url: hostCorporationApi.trade_bank_commercial_acceptance_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function bank_commercial_acceptance_update (parameter, bank_commercial_acceptance_id) {
  return request({
    url: hostCorporationApi.trade_bank_commercial_acceptance_update + bank_commercial_acceptance_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function bank_commercial_acceptance_delete (bank_commercial_acceptance_id) {
  return request({
    url: hostCorporationApi.trade_bank_commercial_acceptance_delete + bank_commercial_acceptance_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 列表
 */
export function bank_commercial_acceptance_attachment_list (parameter) {
  return request({
    url: hostCorporationApi.trade_bank_commercial_acceptance_attachment_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function bank_commercial_acceptance_attachment_create (parameter) {
  return request({
    url: hostCorporationApi.trade_bank_commercial_acceptance_attachment_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function bank_commercial_acceptance_attachment_update (parameter, bank_commercial_acceptance_attachment_id) {
  return request({
    url: hostCorporationApi.trade_bank_commercial_acceptance_attachment_update + bank_commercial_acceptance_attachment_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function bank_commercial_acceptance_attachment_delete (bank_commercial_acceptance_attachment_id) {
  return request({
    url: hostCorporationApi.trade_bank_commercial_acceptance_attachment_delete + bank_commercial_acceptance_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
